import { FC } from 'react';
import { CatChip } from '@blocks-react/components/Chip';
import styles from '../NotificationDrawer.module.scss';

interface NotificationChipsProps {
  notificationChip: string;
  handleRemovingChip: (notificationChip: string) => void;
}
export const NotificationChips: FC<NotificationChipsProps> = ({
  notificationChip = '',
  handleRemovingChip
}) => {
  return (
    <CatChip
      className="d-inline-block mb-1 mr-1"
      key={notificationChip}
      onBlChipRemove={() => handleRemovingChip(notificationChip)}
      removable
      data-testid="order-status-chip"
    >
      <div className={styles['notificationchip_ellipsis']}>
        {notificationChip}
      </div>
    </CatChip>
  );
};
